/* eslint-disable sonarjs/no-duplicate-string */
import dayjs from 'dayjs';
import { z } from 'zod';

export const newsSummarySchema = z
  .object({
    id: z.number(),
    title: z.string(),
    description: z.string(),
    text: z.string(),
    source: z.string().nullable(),
    importance_explanation: z.string().nullable().optional(),
    created_at: z.string(),
    updated_at: z.string(),
    summary: z.string().nullable().optional(),
    publish_date: z.string(),
  })
  .transform((raw) => {
    return {
      id: raw.id,
      title: raw.title,
      description: raw.description,
      text: raw.text,
      source: raw.source,
      importanceExplanation: raw.importance_explanation ?? undefined,
      summary: raw.summary ?? undefined,
      createdAt: dayjs(raw.created_at).format('DD MMMM YYYY'),
      updatedAt: dayjs(raw.updated_at).format('DD MMMM YYYY'),
      publishDate: dayjs(raw.publish_date).format('DD MMMM YYYY'),
    };
  });

export type NewsSummaryEntityApi = z.input<typeof newsSummarySchema>;
export type NewsSummaryEntity = z.infer<typeof newsSummarySchema>;

export const newsSummaryResponseSchema = z.object({
  data: newsSummarySchema,
});

export type NewsSummaryResponseApi = z.input<typeof newsSummaryResponseSchema>;
export type NewsSummaryResponse = z.infer<typeof newsSummaryResponseSchema>;
